import React, {FC} from 'react';
import {Button, StrictInputProps} from 'semantic-ui-react';
import {Editor, Element, Node, Transforms} from 'slate';
import {
  ReactEditor,
  RenderElementProps,
  useReadOnly,
  useSlate,
} from 'slate-react';

import * as S from './cta-button.styles';
import {BlockWrapper} from './drag-drop';

export type CTA = Element & {
  type: 'cta-button';
  link?: string;
  buttonText?: string;
};

export const isCTA = (node: Node): node is CTA => node.type === 'cta-button';

export const CTAElement: FC<
  RenderElementProps & {
    element: CTA;
  }
> = ({attributes, element, children}) => {
  const {buttonText = '', link = ''} = element;
  const urlPrefix = link.startsWith('/') ? '' : 'https://';

  const readOnly = useReadOnly();
  const editor = useSlate();

  return (
    <BlockWrapper attributes={attributes} element={element}>
      {!readOnly && (
        <div contentEditable={false}>
          <S.CTAInput
            placeholder="Set your button text"
            value={buttonText}
            onChange={
              (e => {
                Transforms.setNodes(
                  editor,
                  {buttonText: e.target.value},
                  {at: ReactEditor.findPath(editor, element)}
                );
              }) as StrictInputProps['onChange']
            }
          />
          <S.CTAInput
            placeholder="Set your button link"
            value={link}
            onChange={
              (e => {
                Transforms.setNodes(
                  editor,
                  {link: e.target.value},
                  {at: ReactEditor.findPath(editor, element)}
                );
              }) as StrictInputProps['onChange']
            }
          />
        </div>
      )}
      <S.CTAContainer contentEditable={false}>
        <Button
          primary
          content={buttonText || 'Click'}
          target="_blank"
          href={urlPrefix + link}
        />
        {children}
      </S.CTAContainer>
    </BlockWrapper>
  );
};

export const withCTA = <T extends Editor>(editor: T) => {
  const {isVoid} = editor;

  editor.isVoid = element => {
    return isCTA(element) ? true : isVoid(element);
  };
  return editor;
};
